module.exports = __webpack_public_path__ + "img/icon-close.b098a76c.svg";